/* eslint-disable react/jsx-props-no-spreading */
import isFunction from 'lodash/isFunction';
import mapValues from 'lodash/mapValues';
import React from 'react';
import { useSelector } from 'react-redux';
import * as solutionHelpers from 'utils/formatter';
import * as costHelpers from 'utils/cost';
import ja from "../global/locales/ja/main.json";
import en from "../global/locales/en/main.json";
import { getSafeValue } from '../utils/security';
import { RootState } from '../store';

const translations = { en, ja };

const mapFunction = (fn: any, units: any) =>
  isFunction(fn) ? (value: any) => fn(value)(units) : fn;

const withTranslation = (Component: any): any => {
  const WithTranslation = React.forwardRef<any, any>((props, ref) => {
    const user = useSelector((state: RootState) => state.user);

    const language = user?.language ?? 'en';

    const linkLang = language === 'el' ? 'gr-el' : `${language}-${language}`;

    const { units, ...currentTranslations } = getSafeValue(translations, language) ?? translations.en;

    const helpers = {
      ...mapValues(solutionHelpers, (fn) => mapFunction(fn, units)),
      ...mapValues(costHelpers, (fn) => mapFunction(fn, units)),
    };

    return (
      <Component
        ref={ref}
        helpers={helpers}
        translations={currentTranslations}
        linkLang={linkLang}
        {...props}
      />
    );
  });

  WithTranslation.displayName = `withTranslation(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WithTranslation;
};

export default withTranslation;
